import { OrganisationDto } from '@dhl/mdp-api'
import { convertToTerminalDataDto, type Terminal } from '~/modules/terminals/model'

export const convertToTerminalDto = (terminal: Terminal): OrganisationDto => ({
  ...terminal,
  data: convertToTerminalDataDto(terminal.data),
})
